import {
    GETBLOCKCOUNTRYLIST_SUCCESS,
    GETBLOCKCOUNTRYLIST_FAILED,
    RESET_GETBLOCKCOUNTRYLIST,
    LOADING_GETBLOCKCOUNTRYLIST,
    NETWORK_ERROR_GETBLOCKCOUNTRYLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETBLOCKCOUNTRYLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETBLOCKCOUNTRYLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETBLOCKCOUNTRYLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETBLOCKCOUNTRYLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETBLOCKCOUNTRYLIST:
            return (state = initialState);
        default:
            return state;
    }
};
